export class Antibiotic {

    Id: number;
    Title: string;
    ForeignTitle: string;

    constructor() {
    }
}